import { useEffect, useState } from "react";

function useZoomAwareSize() {
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    const checkZoom = () => {
      const dpr = window.devicePixelRatio || 1;
      setIsZoomed(dpr > 1.1); // for 125%
    };
    checkZoom();
    window.addEventListener('resize', checkZoom);

    return () => {
      window.removeEventListener('resize', checkZoom);
    };
  }, []);

  return isZoomed;

}
export default useZoomAwareSize;